import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineFileAdd } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { MdCardMembership, MdOutlinePostAdd } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { fetchApi } from "../../../api/api";
import { RiArticleFill } from "react-icons/ri";

type Props = {};

const btnStyle = {
  borderRadius: "50px",
  padding: "10px 15px",
  gap: "5px",
  width: { xs: "45%", sm: "auto" },
};

const iconStyle = { color: "#fff", fontSize: "1rem" };

const typographyStyle = {
  whiteSpace: "nowrap",
  fontSize: "0.8rem",
  color: "#fff",
};

const InstructorButtons = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const deleteAccountHandler = () => {
    fetchApi("/instructor-account", "DELETE");
    navigate("/");
  };
  return (
    <Box
      sx={{
        display: "flex",
        gap: "20px",
        alignItems: "center",
        padding: "20px 0",
        flexWrap: { xs: "wrap",xlg: "nowrap" },
        justifyContent: { xs: "center", md: "flex-start" },
      }}
    >
      <Button
        color="primary"
        variant="contained"
        onClick={() => navigate("/add-course")}
        sx={btnStyle}
      >
        <MdOutlinePostAdd style={iconStyle} />
        <Typography sx={typographyStyle}>{t("ProfileCreateCourse")}</Typography>
      </Button>
      <Button
        color="myorange2"
        variant="contained"
        onClick={() => navigate("/add-test")}
        sx={btnStyle}
      >
        <AiOutlineFileAdd style={iconStyle} />
        <Typography sx={typographyStyle}>{t("ProfileCreateTest")}</Typography>
      </Button>
      <Button
        variant="contained"
        color="myred2"
        onClick={() => navigate("/add-blog")}
        sx={btnStyle}
      >
        <RiArticleFill style={iconStyle} />
        <Typography sx={typographyStyle}>{t("ProfileCreateBlog")}</Typography>
      </Button>
     
      <Button
        color="mypurple2"
        variant="contained"
        onClick={() => navigate("/profile/edit")}
        sx={btnStyle}
      >
        <FiEdit style={iconStyle} />
        <Typography sx={typographyStyle}>{t("ProfileEditProfile")}</Typography>
      </Button>
    </Box>
  );
};

export default InstructorButtons;
